import { HttpInterceptorFn } from '@angular/common/http';
import { LoaderService } from '../../services/loader/loader.service';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

let totalRequests = 0;
export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoaderService);
  totalRequests++;
  loadingService.setLoading(true);
  return next(req).pipe(
    finalize(() => {
      totalRequests--;
      if (totalRequests == 0) {
        loadingService.setLoading(false);
      }
    })
  );
};